import { ActivityIndicator, Platform, Pressable, View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useOfflinePacksSettingsPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.settings.offline-packs.navigator";
import { useSlowStaticNetwork } from "#use-slow-static-network";

export function SlowNetworkNotice() {
  const { isDegraded, reason } = useSlowStaticNetwork();
  const packsNavigator = useOfflinePacksSettingsPageNavigator();
  return (
    <View className="flex-1 items-center justify-center gap-3 p-6">
      <ActivityIndicator />
      {isDegraded ? (
        <>
          <Text className="text-center text-[13px] text-muted-foreground">
            {reason === "failed"
              ? "Can’t reach Han’s servers. Check your connection."
              : "This is taking longer than usual — your connection looks slow."}
          </Text>
          {Platform.OS !== "web" ? (
            <>
              <Pressable
                accessibilityLabel="Open Offline Packs"
                accessibilityRole="button"
                className="rounded-xs border border-border px-4 py-2 active:opacity-80"
                onPress={() => packsNavigator.push.mutate()}
                testID="slow-network-offline-packs"
              >
                <Text className="text-[13px] font-semibold">Offline Packs</Text>
              </Pressable>
              <Text className="text-center text-[11px] text-muted-foreground">
                Download level packs while connected to study them offline.
              </Text>
            </>
          ) : null}
        </>
      ) : null}
    </View>
  );
}
